import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {GameCenterIndexPageFetchHandler} from "./game-center.index-page.fetch-handler";
import {PopulateDataHandler} from "../../../../../infrastructure/handlers/populate-data-handler";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {GameCenterIndexPageBreadcrumbsHandler} from "./game-center.index-page.breadcrumbs-handler";
import {GameCenterIndexPageWscStoryHandler} from "./game-center.index-page.wsc-story.handler";
import {GameCenterContainerMetadataFetchHandler} from "../../../handlers/game-center-container.metadata.fetch-handler";

export class GameCenterIndexPageHandlers extends HandlerList {
  static injectables = [
    GameCenterIndexPageFetchHandler,
    GameCenterIndexPageBreadcrumbsHandler,
    GameCenterContainerMetadataFetchHandler,
    PopulateDataHandler,
    GameCenterIndexPageWscStoryHandler,
    TimingHandler
  ];

  constructor(
      gameCenterIndexPageHomePageFetchHandler: GameCenterIndexPageFetchHandler,
      gameCenterIndexPageBreadcrumbsHandler: GameCenterIndexPageBreadcrumbsHandler,
      gameCenterContainerMetadataFetchHandler: GameCenterContainerMetadataFetchHandler,
      populateDataHandler: PopulateDataHandler,
      gameCenterIndexPageWscStoryHandler: GameCenterIndexPageWscStoryHandler,
      timingHandler: TimingHandler
  ) {
    super();

    [
      gameCenterIndexPageHomePageFetchHandler,
      gameCenterIndexPageBreadcrumbsHandler,
      gameCenterContainerMetadataFetchHandler,
      populateDataHandler,
      gameCenterIndexPageWscStoryHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
